import { useQuery } from "@tanstack/react-query";
import { getVehicleCurrentStatus } from 'apis/vehicleApis';
import VEHICLE from "assets/images/icons/vehicle-white.svg";
import Loading from "components/Common/Loading";
import APIError from "components/Common/APIError";
// import { useMemo } from "react";
// import { setPageLoader } from "reducers/loaderSlice";
import { useDispatch } from "react-redux";

const VehicleCurrentStatus = ({ vehicle }) => {
  const dispatch = useDispatch()

  const {
    data: statusData,
    isLoading: statusIsLoading,
    isError: statusIsError,
    error: statusError
  } = useQuery({
    queryKey: ['vehicleCurrentStatus', vehicle?.vehId],
    queryFn: () => getVehicleCurrentStatus(vehicle?.vehId),
    keepPreviousData: true,
    enabled: !!(vehicle?.vehId),
    refetchInterval: 1 * 60 * 1000,
  });

  // useMemo(() => {
  //   if(statusData === "RUNNING"){
  //     dispatch(setPageLoader("live"))
  //   }else{
  //     dispatch(setPageLoader(null))
  //   }
  // }, [statusData])

  return (
    <>
    { statusIsLoading && <Loading/>}
    { statusIsError && <APIError message={statusError?.message}/>}
    {!statusError && 
      <div
        className={"vehicle-current-status-card " + statusData?.toLowerCase()}
      >
        <img src={VEHICLE} alt="vehicle" className="vehicle-img mr05" />
        <div className="vehicle-status-text">{statusData}</div>
      </div>
    }
    </>
  );
}

export default VehicleCurrentStatus;
